import axios from "axios";

export default axios.create({
  baseURL: "https://areco.gob.ar:9525/api/home",
  headers: {
    "Content-type": "application/json"
  }
});